module.exports = __webpack_public_path__ + "img/formatador_unico_img2.eea9b346.jpg";